// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NnRqa {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.VtCep {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.zC5nI {
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 0.15s ease;
}

.nRTNX {
    opacity: 1;
}

.b4JzM {
    border-radius: 26px;
    z-index: 1000;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

.rOx2m {
    opacity: 0;
    transform: scale(0);
}

.mDK4X {
    opacity: 1;
    transform: scale(1.05);
    transition: opacity 0.15s ease-out, transform 0.15s ease-out;
}

.rMlxE {
    opacity: 1;
    transform: scale(1);
    transition: transform 0.1s ease-out;
}

.aiwBC {
    opacity: 0;
    transform: scale(0);
    transition: opacity 0.15s ease-in, transform 0.15s ease-in;
}

.i9vEA {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/BaseModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,4DAA4D;AAChE;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,0DAA0D;AAC9D;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;AACpB","sourcesContent":[".overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n}\n\n.backdropContainer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n.backdrop {\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    transition: opacity 0.15s ease;\n}\n\n.backdropVisible {\n    opacity: 1;\n}\n\n.modalContainer {\n    border-radius: 26px;\n    z-index: 1000;\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n}\n\n.modalInitial {\n    opacity: 0;\n    transform: scale(0);\n}\n\n.modalEntering {\n    opacity: 1;\n    transform: scale(1.05);\n    transition: opacity 0.15s ease-out, transform 0.15s ease-out;\n}\n\n.modalVisible {\n    opacity: 1;\n    transform: scale(1);\n    transition: transform 0.1s ease-out;\n}\n\n.modalExiting {\n    opacity: 0;\n    transform: scale(0);\n    transition: opacity 0.15s ease-in, transform 0.15s ease-in;\n}\n\n.contentContainer {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `NnRqa`,
	"backdropContainer": `VtCep`,
	"backdrop": `zC5nI`,
	"backdropVisible": `nRTNX`,
	"modalContainer": `b4JzM`,
	"modalInitial": `rOx2m`,
	"modalEntering": `mDK4X`,
	"modalVisible": `rMlxE`,
	"modalExiting": `aiwBC`,
	"contentContainer": `i9vEA`
};
export default ___CSS_LOADER_EXPORT___;
